<form *ngIf="form" [formGroup]="form" (ngSubmit)="save()">
    <div class="modal-header">
        <h4 class="modal-title pull-left" translate>job.Add.new.service</h4>
    </div>
    <div class="modal-body add-part-kit">
        <div class="form-group">
            <label class="control-label required_field" translate>job.select.a.service</label>
            <div class="controls">
                <input
                    type="text"
                    csSelect2
                    [select2Config]="select2Config"
                    (onChange)="onSelectingCondition($event)"
                    formControlName="pricing_item"
                />
            </div>
        </div>


        <ng-container *ngIf="seletedItem">

            <div class="form-group required" [class.has-error]="f.min_included.invalid && (f.min_included.touched || f.min_included.dirty)">
                <label class="control-label required_field" translate>no.of.min.included</label>
                <div class="controls">
                    <input
                        type="number"
                        formControlName="min_included"
                        required
                        step="1"
                        min="0"
                    />
                </div>
                <div *ngIf="f.min_included.invalid && (f.min_included.touched || f.min_included.dirty)" class="control-error-message">
                    <span *ngIf="f.min_included.errors?.required" translate>job.enter.valid.minutes.included</span>
                    <span *ngIf="f.min_included.errors?.pattern" translate>job.enter.valid.minutes.included</span>
                    <span *ngIf="f.min_included.errors?.min">job.minutes.cannot.negative</span>
                </div>
            </div>

            <div class="form-group required" [class.has-error]="f.unitprice.invalid && (f.unitprice.touched || f.unitprice.dirty)">
                <label class="control-label required_field" translate>Unit.Price</label>
                <div class="controls">
                    <input
                        type="text"
                        formControlName="unitprice"
                        required
                        readonly
                    />
                </div>
                <div *ngIf="f.unitprice.invalid && (f.unitprice.touched || f.unitprice.dirty)" class="control-error-message">
                    <span *ngIf="f.unitprice.errors?.required">job.field.required</span>
                    <span *ngIf="f.unitprice.errors?.pattern" translate>job.field.required</span>
                </div>
            </div>

            <div class="form-group required" [class.has-error]="f.qty.invalid && (f.qty.touched || f.qty.dirty)">
                <label class="control-label required_field" translate>Quantity</label>
                <div class="controls">
                    <input
                        type="number"
                        class="qty-input"
                        formControlName="qty"
                        required
                        min="0"
                        (input)="onQtyKeyup()"
                    />
                </div>
                <div *ngIf="f.qty.invalid && (f.qty.touched || f.qty.dirty)" class="control-error-message">
                    <span *ngIf="f.qty.errors?.required" translate>Please.enter.valid.quantity</span>
                    <span *ngIf="f.qty.errors?.pattern" translate>Please.enter.valid.quantity</span>
                    <span *ngIf="f.qty.errors?.min" translate>job.qty.greater.zero</span>
                </div>
            </div>

            <div class="form-group required" [class.has-error]="f.tax.invalid && (f.tax.touched || f.tax.dirty)">
                <label class="control-label required_field" >{{this.taxLable}} </label>
                <div class="controls tax-items">
                    <input type="hidden" csSelect2 [select2Config]="select2TaxConfig" id="tax"
                           formControlName="tax" [placeholder]="'-- please select --'" class="chosen-select full-width-select">
                </div>
                <div *ngIf="f.tax.invalid && (f.tax.touched || f.tax.dirty)" class="control-error-message">
                    <span *ngIf="f.tax.errors?.required" translate>Please.Select.Valid.Part.Taxitem</span>
                </div>
            </div>


            <div class="form-group required" [class.has-error]="f.total.invalid && (f.total.touched || f.total.dirty)">
                <label class="control-label required_field" translate>Total</label>
                <div class="controls">
                    <input
                        type="text"
                        class="qty-input"
                        formControlName="total"
                        id="total"
                        required
                        readonly
                    />
                </div>
                <div *ngIf="f.total.invalid && (f.total.touched || f.total.dirty)" class="control-error-message">
                    <span *ngIf="f.total.errors?.required" translate>Please.Enter.Valid.Total</span>
                </div>
            </div>

        </ng-container>


    </div>
    <div class="modal-footer">
        <a href="javascript:void(0)" class="btn" (click)="bsModalRef.hide()">Cancel</a>
        <button
            #saveBtn
            [disabled]="form.invalid || action == 'saving'"
            class="btn btn-primary"
        >
            <span [hidden]="action == 'saving'">Save</span>
            <span [hidden]="action != 'saving'">Saving</span>
        </button>
    </div>
</form>
